var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 pb-3 entity-row-6"},[_c('img',{staticClass:"img-fluid",attrs:{"src":this.cmsUrl + _vm.doorCheckDoorImage.image.image_url,"alt":_vm.doorCheckDoorImage.image.alt_text}})])}
var staticRenderFns = []

export { render, staticRenderFns }